import { unstable_batchedUpdates } from 'react-dom';

const useMergeRender = unstable_batchedUpdates;

export default useMergeRender;